/* ==========================================================================
 *  Close trigger
 * ======================================================================= */
function fn_parts_close_block(){
	if ($('.js-close-trigger').length){
          $('.js-close-trigger').on('click', function () {
	        $(this).closest('.js-close-block').fadeOut();
	    });
	}
	if ($('.js-close-trigger-active').length){
          $('.js-close-trigger-active').on('click', function () {
	        $(this).closest('.js-close-block').removeClass('active');
	    });
	}
}